module.exports = __webpack_public_path__ + "static/media/wavm8s-026-phrixus.e515a68.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/wav/wavm8s-026-phrixus.mp3
// module id = oBiA
// module chunks = 0